import {TemplateAsset} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import {addTemplateAssets as addTemplateAssetsAction} from '../movieAssets.slice';
import {CLDispatch} from 'common/src/redux/store';

export default function addTemplateAssets(newAssets: TemplateAsset[]) {
  return async (dispatch: CLDispatch) => {
    dispatch(addTemplateAssetsAction(newAssets));
  };
}
